import { ProductType } from '../../Quotes/types/productTypes';

export const isP2NNI = (productType: ProductType | null | undefined) => {
  return productType === ProductType.P2NNI;
};
